import { FC } from 'react'
import { getRequestTypeName } from 'services/Utilities'

const TimeOffInfo: FC<{ _id: string; vacationTypeId: string }> = ({ _id, vacationTypeId }) => {
  if (!vacationTypeId) return null

  return (
    <small className="text-complimentary">
      <i className="fas fa-info-circle mr-2"></i>
      <a href={`/my/timeoff/${_id}`} className="text-complimentary text-link mt-1">
        {getRequestTypeName(vacationTypeId)}
      </a>
    </small>
  )
}

export { TimeOffInfo }
